declare namespace $ {

	export class $mol_keyboard_state extends $mol_plugin {
		down( next?: any ): any
		up( next?: any ): any
		event( ): ({ 
			keydown( next?: ReturnType< $mol_keyboard_state['down'] > ): ReturnType< $mol_keyboard_state['down'] >,
			keyup( next?: ReturnType< $mol_keyboard_state['up'] > ): ReturnType< $mol_keyboard_state['up'] >,
		})  & ReturnType< $mol_plugin['event'] >
		key( ): Record<string, any>
	}
	
}

//# sourceMappingURL=state.view.tree.d.ts.map